<script setup lang="ts">
import { RouterView } from 'vue-router';
import SideNavV3 from '@/presentation/components/side-nav/SideNavV3.vue';
import AutoMountPoint from '@/presentation/components/auto-mount-point/AutoMountPoint.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useClient } from '@/presentation/composables/use-client';
import { useTooltip } from '@telecom/shared/composables/use-tooltip';
import { useClassification } from '@telecom/shared/modules/classification-module/use-classification';
import { usePackageStatusDialog } from '@/presentation/composables/use-package-status-dialog';
import '@patsnap-biz/package-status-dialog/lib/style';

import VueElementInspector from '@/presentation/components/VueElementInspector.vue';
import GlobalWelcomeCreditsDialog from '@/presentation/components/home/GlobalWelcomeCreditsDialog.vue';

useTooltip();
useClassification();
// 企业账号套餐状态弹窗
usePackageStatusDialog();
// 绑定路由参数
const route = useRoute();
const taskId = computed(() => route.query.taskId as string);
// 注册主题
const { isEureka } = useClient();
const theme = computed(() => isEureka.value ? 'patsnapRD' : 'patsnapIP');
const isDev = import.meta.env.DEV;
// 临时解决方案,pricing会嵌入到rd,所以需要去掉头
const isShowHeader = computed(() => {
    const name = route.name as string;
    return name && !['agent-landing', 'pricing'].includes(name);
});
</script>

<template>
    <div :data-theme="theme" class="app-container w-full h-full overflow-hidden flex flex-row">
        <SideNavV3 v-if="isShowHeader" class="flex-shrink-0" />
        <div class="app-body overflow-auto w-full h-full mx-auto">
            <RouterView v-slot="{ Component }">
                <Transition name="fade">
                    <component :is="Component" :key="taskId" />
                </Transition>
            </RouterView>
        </div>

        <AutoMountPoint />
        <GlobalWelcomeCreditsDialog />
        <VueElementInspector v-if="isDev" />
    </div>
</template>

<style lang="scss">
.app-body {
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
}

[popover] {
    margin: 0;
    padding: 0;
}
</style>
